import { render, staticRenderFns } from "./dedicated-filter.vue?vue&type=template&id=bc2b6696&"
import script from "./dedicated-filter.vue?vue&type=script&lang=js&"
export * from "./dedicated-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports